import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import { SALE_DATE_FILTER, SaleDateFilter } from '@/constants/saleFilters';

/** Single sale type code (L or R). Used in multi-select. */
export type SaleTypeFilterValue =
  | 'SL'
  | 'PL'
  | 'XL'
  | 'ML'
  | 'SR'
  | 'PR'
  | 'XR'
  | 'MR';

export const SALE_DATE_FILTER_PARAM = 'saleDateFilter';
export const SALE_TYPE_FILTER_PARAM = 'saleTypeFilter';

const DEFAULT_SALE_DATE_FILTER: SaleDateFilter = SALE_DATE_FILTER.CURRENT;

/** Listing-type codes only (for multi-select options). Empty selection = All. */
export const SALE_TYPE_MULTI_OPTIONS: SaleTypeFilterValue[] = [
  'SL',
  'PL',
  'XL',
  'ML',
];

export function useCatalogueFilters() {
  const params = useSearchParams();

  const saleDateFilter = (params?.get(SALE_DATE_FILTER_PARAM) ||
    DEFAULT_SALE_DATE_FILTER) as SaleDateFilter;

  const saleTypeFilterRaw = params?.get(SALE_TYPE_FILTER_PARAM) ?? '';

  const saleTypeFilterArray = useMemo(() => {
    if (!saleTypeFilterRaw.trim()) return [] as string[];
    return saleTypeFilterRaw
      .split(',')
      .map((s) => s.trim())
      .filter((s) => s.length === 2);
  }, [saleTypeFilterRaw]);

  return {
    saleDateFilter:
      saleDateFilter === SALE_DATE_FILTER.ALL
        ? SALE_DATE_FILTER.ALL
        : DEFAULT_SALE_DATE_FILTER,
    saleTypeFilter: saleTypeFilterRaw,
    saleTypeFilterArray,
  };
}
